/**
 * SPEC-185 — CA-008: la expiración de sesión la detecta el backend en CUALQUIER request a
 * `/api/*`, no solo durante el login. `apiFetch` publica el aviso aquí y el módulo de auth
 * se suscribe para cerrar la sesión y volver al gate con el banner "Tu sesión expiró".
 *
 * Vive en `shared/` (no en `modules/auth/`) para que `apiFetch` no tenga que importar un
 * módulo de negocio: el cliente HTTP solo avisa, la reacción la decide el módulo de auth.
 */
type Suscriptor = () => void;

const suscriptores = new Set<Suscriptor>();

/** Devuelve la función para cancelar la suscripción (útil en el cleanup de un efecto). */
export function suscribirSesionExpirada(suscriptor: Suscriptor): () => void {
  suscriptores.add(suscriptor);
  return () => {
    suscriptores.delete(suscriptor);
  };
}

export function notificarSesionExpirada(): void {
  suscriptores.forEach((suscriptor) => suscriptor());
}
